import { E_ADMIN_ROLE, TAdmin } from "../Types";

export enum E_LOCAL_STORAGE_KEY {
  USER = "user",
  USER_PERMISSIONS = "user_permissions",
  NOTIFICATION_SOUND_ENABLED = "notification_sound_enabled",
  APP_CONTROL_LAST_SEEN_WARNING_ID = "app_control_last_seen_warning_id",
  NOTIFICATION_PERMISSION_POPUP_ANSWERED = "notification_permission_popup_answered"
}

export enum E_SESSION_STORAGE_KEY {
  COUNTS = "counts"
}
export enum E_STORAGE_TYPE {
  SESSION = "SESSION",
  LOCAL = "LOCAL"
}

type TStorageDefaults = {
  [E_LOCAL_STORAGE_KEY.USER]: TAdmin;
  [E_LOCAL_STORAGE_KEY.USER_PERMISSIONS]: number[];
  [E_LOCAL_STORAGE_KEY.NOTIFICATION_SOUND_ENABLED]: boolean;
  [E_LOCAL_STORAGE_KEY.APP_CONTROL_LAST_SEEN_WARNING_ID]: number;
  [E_LOCAL_STORAGE_KEY.NOTIFICATION_PERMISSION_POPUP_ANSWERED]: boolean;
  [E_SESSION_STORAGE_KEY.COUNTS]: Record<string, number>;
};

export const STORAGE_DEFAULTS: TStorageDefaults = {
  [E_LOCAL_STORAGE_KEY.USER]: {
    id: -1,
    username: "",
    fullName: "",
    role: E_ADMIN_ROLE.NO_ROLE,
    lastLogin: "",
    needResetPassword: false
  },
  [E_LOCAL_STORAGE_KEY.USER_PERMISSIONS]: [],
  [E_LOCAL_STORAGE_KEY.NOTIFICATION_SOUND_ENABLED]: true,
  [E_LOCAL_STORAGE_KEY.APP_CONTROL_LAST_SEEN_WARNING_ID]: -1,
  [E_LOCAL_STORAGE_KEY.NOTIFICATION_PERMISSION_POPUP_ANSWERED]: false,
  [E_SESSION_STORAGE_KEY.COUNTS]: {}
};
export type TStorageKey = E_LOCAL_STORAGE_KEY | E_SESSION_STORAGE_KEY;
